import { BeatLoader } from "react-spinners";

const CircleButton = ({ backgroundColor, onClick, content, loading }) => (
    <div className="circle-start room" style={{ background: backgroundColor }}>
        {loading ? (
            <p className="circle-content">
                <BeatLoader color="white" margin={2} size={10} />
            </p>
        ) : (
            <p type="button" onClick={onClick} className="circle-content">
                {content}
            </p>
        )}
    </div>
);

export default CircleButton